/**
 * Creates a base-64 encoded ASCII string from a "string"
 * @param input
 */
export const encodeBase64 = (input: string): string => {
    return btoa(input);
};
